module.exports = __webpack_public_path__ + "static/media/auditorium.3cd4e356.jpg";